<ng-content select="app-push-toast" />

@for (toast of messages$ | async; track trackMessage($index, toast)) {
  <app-toast
    [@fadeMessageAnimation]="'resting'"
    [show]="toast.shown"
    [title]="toast.title"
    [text]="toast.text"
    [dismissable]="toast.dismissable"
    [icon]="toast.icon"
    [button]="toast.button"
    [duration]="toast.duration"
    (action)="onToastAction(toast, $event)"
    (closed)="onToastClosed(toast, $event)"
  />
}

<ng-content />
